import React, { useEffect, useState } from "react";
import { Box, IconButton, Divider } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";

import api from "../api/axiosConfig";
import LogoHeader from "../components/LogoHeader";

export default function ExplorePage() {
  const [hasNotifications, setHasNotifications] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (!user?.id) return;

    const checkNotifications = async () => {
      try {
        const res = await api.get(`/notifications/${user.id}`);
        setHasNotifications((res.data.notifications || []).length > 0);
      } catch (err) {
        console.error("Notification check failed", err);
      }
    };

    checkNotifications();
    const notifInterval = setInterval(checkNotifications, 15000);

    return () => {
      clearInterval(notifInterval);
    };
  }, [user?.id]);

  return (
    <Box
      sx={{
        bgcolor: "#FFFFFF",
        px: 2,
        pt: 1.5,
      }}
    >
      {/* Header */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
        <LogoHeader />

        <IconButton
          onClick={() => {
            window.dispatchEvent(new Event("open-notifications"));
          }}
          sx={{ position: "relative" }}
        >
          <NotificationsIcon
            sx={{
              color: hasNotifications ? "#16A34A" : "#9CA3AF",
            }}
          />

          {hasNotifications && (
            <Box
              sx={{
                position: "absolute",
                top: 6,
                right: 6,
                width: 8,
                height: 8,
                bgcolor: "#EF4444",
                borderRadius: "50%",
              }}
            />
          )}
        </IconButton>
      </Box>

      <Divider sx={{ mb: 2 }} />

      {/* ✅ Pulse section removed */}
    </Box>
  );
}
